import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { useDispatch } from 'react-redux';

import { useConfirm } from 'material-ui-confirm';
import Grid from 'material/components/Grid';

import { deleteMeeting, fetchAllMeetings } from 'store/actions/meetings';
import { setSnackbarSuccess } from 'store/actions/global';

import { BreadcrumbsNavigation, Callout, Container, LinkButton } from 'common/components';
import TopCard from 'common/containers/TopCard';

import MeetingsTable from '../components/MeetingsTable';

const Meetings = () => {
  const dispatch = useDispatch();

  const { organizationUuid } = useParams();

  const [meetings, setMeetings] = useState([]);

  const [isFetching, setIsFetching] = useState(true);

  const breadcrumbs = [
    {
      link: `/${organizationUuid}/contacts/lists`,
      name: 'Lists',
    },
    {
      link: '',
      name: 'Meetings',
    },
  ];

  useEffect(() => {
    dispatch(fetchAllMeetings(organizationUuid)).then(data => {
      setMeetings(data || []);
      setIsFetching(false);
    });
  }, []);

  const confirm = useConfirm();

  const handleRemoveMeeting = meetingUuid => {
    confirm({
      confirmationText: 'Remove',
      title: 'Remove Meeting?',
    })
      .then(() => dispatch(deleteMeeting(meetingUuid)))
      .then(() => dispatch(fetchAllMeetings(organizationUuid)))
      .then(data => setMeetings(data || []))
      .then(() => dispatch(setSnackbarSuccess()));
  };

  return (
    <>
      <BreadcrumbsNavigation isLoading={isFetching} links={breadcrumbs} />
      <Container marginBottom="40">
        <Grid container>
          <TopCard
            backButtonLink={`/${organizationUuid}/campaigns`}
            restActions={
              <LinkButton
                color="primary"
                name="Log Meeting"
                to={`/${organizationUuid}/meetings/new`}
                variant="newItem"
              />
            }
            title="Meetings"
          />
        </Grid>
        <Grid container>
          <Callout
            severity="info"
            sx={{
              mb: 2,
              width: '100%',
            }}
          >
            Meetings is currently in beta status and we encourage your feedback to help make the
            product better!
          </Callout>
        </Grid>
        <Grid container>
          <MeetingsTable
            handleRemoveMeeting={handleRemoveMeeting}
            isLoading={isFetching}
            meetings={meetings}
          />
        </Grid>
      </Container>
    </>
  );
};

export default Meetings;
